import axios from '@/libs/api.request'
import md5 from 'js-md5'
import { getToken } from '../libs/util'

/**
 * 登录
 * @param {*} param0
 */
export const login = (account, password) => {
  const params = {
    account,
    psw: md5(password),
    login_type: 1
  }

  return axios.request({
    url: '/Api/V1_Login/doLogin',
    params,
    method: 'post'
  })
}

export const getBaseUserInfo = (queryVal, queryType) => {
  return axios.request({
    url: '/hall/Userinfo/getBaseUserInfo',
    method: 'get',
    params: {query_val: queryVal, query_type: queryType}
  })
}

export const getLinkInfo = () => {
  return axios.request({
    url: '/Api/V1_User/getLinkInfo',
    method: 'get'
  })
}

export const changeLinkInfo = (params) => {
  return axios.request({
    url: '/Api/V1_User/changeUserLinkInfo',
    method: 'post',
    params
  })
}

export const getUserInfo = () => {
  var params = { token: getToken() }
  return axios.request({
    url: '/Hall/UserInfo/getUserLoginData',
    method: 'post',
    params
  })
}

export const getUserAssetsData = () => {
  return axios.request({
    url: '/Api/V1_User//getUserAssetsData',
    method: 'get'
  })
}

export const userFeedback = (params) => {
  return axios.request({
    url: '/Account/Info/userGameFeedback',
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js